// 제조국 목록
export const COUNTRIES = [
    '대한민국',
    '중국',
    '베트남',
    '미얀마',
    '방글라데시',
    '일본',
    '태국',
    '인도',
    '인도네시아',
    '캄보디아',
    '파키스탄',
    '우즈베키스탄',
    '이탈리아',
];

// 사이즈 목록
export const SIZES_ALPHA = ['Free', 'XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
export const SIZES_NUMERIC = [
    '44',
    '44반',
    '55',
    '55반',
    '66',
    '66반',
    '77',
    '77반',
    '88',
    '99',
    '75',
    '80',
    '85',
    '90',
    '95',
    '100',
    '103',
    '105',
    '110',
    '115',
    '120',
    '125',
    '130',
];
